import { FC } from 'react';
import { inspiration } from 'data/translationKeys';
import { Body, Heading } from 'components/text';

import styles from './Inspirations.module.scss';
import { useSearchBarContext } from './context';
import Icon from 'components/icons/InspirationCategories';
import { InspirationType } from 'types/types';
import useLocalised from 'customHooks/useLocalised/useLocalised';

interface IInspirationItem {
  inspirationCategories: InspirationType[];
}

const Inspirations: FC<IInspirationItem> = ({ inspirationCategories }) => {
  const { setState } = useSearchBarContext();

  const inspiration_text = useLocalised(inspiration);

  return (
    <div className={styles.inspirationWrapper}>
      <Heading as="h5">{inspiration_text}</Heading>
      {inspirationCategories.map((inspiration, i) => {
        const handleClick = () => {
          setState({
            searchInputValue: inspiration.name,
            showInspirationCategories: false,
            showSearchSuggestions: false,
            urlObject: {
              pathname: inspirationTypeToPathName.inspiration,
              query: {
                [inspirationTypeToIdPropertyName.inspiration]: inspiration.id,
              },
            },
          });
        };
        return (
          <div key={i}>
            {inspiration.isSearchable && (
              <div
                className={styles.inspirationContainer}
                onClick={handleClick}
              >
                <Icon icon={inspiration.icon} />
                <div className={styles.content}>
                  <Body>{inspiration.name}</Body>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Inspirations;

const inspirationTypeToPathName = {
  inspiration: '/search-results-inspirations/[inspirationId]',
};

const inspirationTypeToIdPropertyName = {
  inspiration: 'inspirationId',
};
